import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import type {
  DeleteOrganizationMemberPayload,
  DeleteOrganizationMemberInput,
} from "@casey/db-types";

const DELETE_ORGANIZATION_MEMBER = gql`
  mutation DeleteOrganizationMember($organizationId: UUID!, $userId: String!) {
    deleteOrganizationMember(
      input: { organizationId: $organizationId, userId: $userId }
    ) {
      organizationMember {
        organizationId
        userId
        role
      }
      messages {
        level
        message
        path
      }
    }
  }
`;

export function useDeleteOrganizationMember() {
  return useMutation<
    { deleteOrganizationMember: DeleteOrganizationMemberPayload },
    DeleteOrganizationMemberInput
  >(DELETE_ORGANIZATION_MEMBER);
}
